"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12.32 17.44c-.64-1.301-1.195-2.251-1.664-2.848-.469-.597-1.013-1.003-1.632-1.216-.597-.213-1.44-.32-2.528-.32H4.832v-1.728h4.32c1.195 0 2.165-.299 2.912-.896.747-.619 1.195-1.483 1.344-2.592H4.832V6.08h8.608c-.128-1.109-.565-1.973-1.312-2.592-.747-.619-1.739-.928-2.976-.928h-4.32V.8h14.336v1.76h-5.376c1.195.832 1.867 2.005 2.016 3.52h3.36v1.76h-3.424c-.149 1.28-.672 2.336-1.568 3.168-.896.811-2.027 1.291-3.392 1.44.555.213 1.013.48 1.376.8.384.32.757.8 1.12 1.44.384.619.875 1.536 1.472 2.752l2.816 5.76h-2.432l-2.816-5.76z"
  }));
}

var _default = 'src/asset/icon/rupee.icon.svg';
exports.default = _default;
//# sourceMappingURL=rupee.icon.js.map